import Head from "next/head";
import { GetServerSideProps } from "next";
import { AnimatePresence } from "framer-motion";
import Div100vh from "react-div-100vh";
import React from "react";
import { RESOURCES_BASE_API } from "@/lib/utils/constants";
import MoneyViewPager from "components/MoneyPersonality/MoneyViewPager";
import { getLatestSurveys, getSurveyCohorts } from "@/lib/utils/personality";
import { SurveyCohortType } from "@/lib/types/personality";
import { PersonalityDataContext } from "@/components/Personality/MptContexts";

type HomePropsType = {
	cohortsMaster?: Array<SurveyCohortType>;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
	let props: HomePropsType = {
		cohortsMaster: [],
	};
	try {
		const surveys = await getLatestSurveys();

		const psychometricSurvey = surveys.find((s) => s.type === 1);
		if (!psychometricSurvey) return { props };

		const surveyResponse = await getSurveyCohorts(psychometricSurvey.id);
		const cohortsMaster = surveyResponse.cohorts;
		props = { cohortsMaster };
	} catch (error) {}

	return { props };
};

export const AllPersonalitiesDataContext: any = React.createContext({});

export default function Home({ cohortsMaster }: HomePropsType) {
	return (
		<>
			<Head>
				<title>SALT</title>
				<meta name="description" content="SALT" />
				<link
					rel="icon"
					href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
				/>
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />

				<meta
					property="og:title"
					content="Find out which money personality you are!"
				/>
				<meta
					name="twitter:title"
					content="Find out which money personality you are!"
				/>

				<meta name="description" content="Sorted or anxious or cautious?" />
				<meta
					property="og:description"
					content="Sorted or anxious or cautious?"
				/>
				<meta
					name="twitter:description"
					content="Sorted or anxious or cautious?"
				/>

				<link
					rel="icon"
					sizes="50x50"
					type="image/x-icon"
					href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
				/>
				<link
					rel="shortcut icon"
					href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
					type="image/x-icon"
				/>
				<link
					rel="apple-touch-icon"
					href={
						RESOURCES_BASE_API +
						"/psychometric/meta/thumbnail-money-personality-test.png"
					}
					type="image/jpeg"
				/>

				{cohortsMaster!.map((item) => {
					{
						return (
							<link key={item.id} rel="preload" as="image" href={item.comic} />
						);
					}
				})}
				<link
					rel="mask-icon"
					href={
						RESOURCES_BASE_API +
						"/psychometric/meta/thumbnail-money-personality-test.png"
					}
				/>

				<meta
					property="og:image"
					itemProp="image"
					content={
						RESOURCES_BASE_API +
						"/psychometric/meta/thumbnail-money-personality-test.png"
					}
				/>
				<meta property="og:url" content="https://app.salt.one/personality" />
				<meta property="og:site_name" content="SALT" />
				<meta property="og:type" content="website" />

				<meta name="twitter:card" content="summary" />
				<meta name="twitter:site" content="@mysaltapp" />
				<meta
					name="twitter:image"
					content={
						RESOURCES_BASE_API +
						"/psychometric/meta/thumbnail-money-personality-test.png"
					}
				/>
				<meta
					name="twitter:image:alt"
					content="Find out which money personality you are!"
				/>
			</Head>
			<Div100vh style={{ width: "100%" }}>
				<AnimatePresence>
					<PersonalityDataContext.Provider value={cohortsMaster}>
						<MoneyViewPager />
					</PersonalityDataContext.Provider>
				</AnimatePresence>
			</Div100vh>
			<style jsx global>{`
				body {
					overflow: hidden;
				}
			`}</style>
			<style jsx>{`
				main {
					position: relative;
					padding: 37px 0 37px 37px;
					background-color: #f8f8f8;
					width: 100%;
					flex: 1;
					overflow-y: auto;
					overflow-x: hidden;
					height: calc(100% - (var(--footer-height)));
				}
				footer {
					width: 100%;
				}
			`}</style>
		</>
	);
}
